<template>
    <div class="deptList">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="info-wrap"
             v-loading="allLoading">
            <div class="info-detail"
                 v-if="hospitalList.length>0">
                <div class="hospital-wrap"
                     :infinite-scroll-distance="30"
                     :infinite-scroll-disabled="hospitalDisabled"
                     v-infinite-scroll="getHospitalData">
                    <div class="info-search-wrap">
                        <el-input size="small"
                                  :style="{width: '230px'}"
                                  placeholder="请输入医院名称搜索"
                                  v-model.trim="searchName"
                                  @keyup.enter.native="getHospitalData('search')">
                            <i slot="suffix"
                            class="iconfont icon-search"
                            @click="getHospitalData('search')"></i>
                        </el-input>
                    </div>
                    <div class="hospital-item text-hidden"
                         :class="[{'choosed-item': index==choosedHospital}]"
                         v-for="(item, index) in hospitalList"
                         :key="index"
                         @click="chooseHospital(item, index)">
                        <el-tooltip effect="dark"
                                    placement="top"
                                    popper-class="short-popper"
                                    v-if="item.hospitalName"
                                    :disabled="item.hospitalName&&item.hospitalName.length < 16? true: false">
                            <span slot="content">
                                {{item.hospitalName}}
                            </span>
                            <span class="text text-hidden">
                                {{item.hospitalName}}
                            </span>
                        </el-tooltip>
                    </div>
                    <div class="hospital-load-text"
                         v-if="hospitalLoading">加载中...</div>
                    <!-- <div class="hospital-load-text"
                         v-if="hospitalNoMore">没有更多了</div> -->
                </div>
                <div class="dept-wrap">
                    <div class="title-wrap">
                        <i class="iconfont icon-tongyongbiaotiicon"></i>
                        <span class="title-text">科室列表</span>
                    </div>
                    <div class="select-form">
                        <div class="option-wrap">
                            <div class="option-item-wrap">
                                <div class="option-item">
                                    <span class="label">科室名称</span>
                                    <el-input size="small"
                                              placeholder="请输入科室名称"
                                              :style="{width: '280px'}"
                                              v-model="selectForm.name">
                                    </el-input>
                                </div>
                                <div class="option-item">
                                    <span class="label">标准科室</span>
                                    <el-select v-model="selectForm.standard"
                                               placeholder="请选择"
                                               size="small"
                                               :style="{width: '240px'}"
                                               @change="handleStandardChange">
                                        <el-option value="all"
                                                   label="全部"></el-option>
                                        <el-option v-for="(item, index) in standardList"
                                                   :key="index"
                                                   :label="item.dictDataValue"
                                                   :value="item.dictDataCode">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="option-item">
                                    <span class="label">创建时间</span>
                                    <el-date-picker size="small"
                                                    clearable
                                                    clear-icon="el-icon-error"
                                                    v-model="selectForm.createTime"
                                                    type="daterange"
                                                    range-separator="-"
                                                    start-placeholder="yyyy-mm-dd"
                                                    end-placeholder="yyyy-mm-dd"
                                                    value-format="yyyy-MM-dd"
                                                    :style="{width: '280px'}"
                                                    @change="handleDateChange"
                                                    :picker-options="datePickerOptions"></el-date-picker>
                                </div>
                                <div class="select-btn-wrap">
                                    <el-button type="primary"
                                               size="small"
                                               @click="searchHospital('search')">查询</el-button>
                                    <el-button type="info"
                                               size="small"
                                               plain
                                               @click="searchHospital('reset')">重置</el-button>
                                </div>
                            </div>
                        </div>
                        <div class="option-wrap">
                            <el-button size="small"
                                       @click="editDetail('add')">新增科室</el-button>
                        </div>
                    </div>

                    <div class="table-wrap">
                        <el-table :data="deptList"
                                  v-loading="loading"
                                  :row-key="getRowKeys"
                                  ref="deptTable"
                                  :expand-row-keys="expands"
                                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                                  style="width: 100%">
                            <el-table-column prop="name"
                                             width="90px"
                                             class-name="table-index-column"
                                             label="序号">
                                <template slot-scope="scope">
                                    {{scope.row.index}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="groupName"
                                             min-width="140px"
                                             label="科室名称">
                                <template slot-scope="scope">
                                    {{scope.row.groupName}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="doctorNumber"
                                             min-width="120px"
                                             label="医生数量">
                                <template slot-scope="scope">
                                    {{scope.row.doctorNumber}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="creator"
                                             min-width="120px"
                                             label="科室类型">
                                <template slot-scope="scope">
                                    {{typeList.find(type =>type.dictDataCode == scope.row.departmentType)
                                ? typeList.find(type =>type.dictDataCode == scope.row.departmentType).dictDataValue
                                : '-'}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="isStandard"
                                             min-width="120px"
                                             label="标准科室">
                                <template slot-scope="scope">
                                    {{standardList.find(standard =>standard.dictDataCode == (scope.row.isStandard+''))
                                ? standardList.find(standard =>standard.dictDataCode == (scope.row.isStandard+'')).dictDataValue
                                : '-'}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="createTime"
                                             min-width="140px"
                                             label="创建时间">
                                <template slot-scope="scope">
                                    {{scope.row.createTime|getDate}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="name"
                                             min-width="90px"
                                             label="操作">
                                <template slot-scope="scope">
                                    <span class="link-btn"
                                          v-if="scope.row.index"
                                          :class="[{'disable-btn': scope.row.isStandard}]"
                                          @click="editDetail('edit', scope.row)">编辑</span>
                                </template>
                            </el-table-column>
                            <div slot="empty"
                                 class="table-none">
                                <div>
                                    <svg-icon icon-class="none1" />
                                </div>
                                <span>暂无数据</span>
                            </div>
                        </el-table>
                    </div>
                    <div class="pagination-wrap">
                        <el-pagination background
                                       @current-change="pageChange"
                                       :current-page.sync="page.current"
                                       :page-size="page.pageSize"
                                       layout="prev, pager, next, jumper"
                                       :total="page.total"></el-pagination>
                    </div>
                </div>

            </div>
            <div class="no-data"
                 v-else>
                <div class="no-data-content">
                    <div>
                        <svg-icon icon-class="none1" />
                    </div>
                    <div class="text">
                        <span>暂无医院数据，请先</span>
                        <span class="addHospital"
                              @click="goHospital()">新增医院</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.info-search-wrap {
    .el-input__suffix {
        top: 6px !important;
    }
}
.deptList {
    .option-wrap {
        .el-button--small {
            width: 86px;
            font-size: 14px;
            padding: 8px 15px;
        }
    }
    .select-btn-wrap {
        .el-button--small {
            width: 80px;
            padding: 8px 15px;
            font-size: 14px;
        }
        .el-button--info.is-plain {
            background: #f5f5f5;
            border-color: #cccccc;
            color: #666;
        }
    }
    .el-table__row:last-child:not(.el-table__row--striped) td,
    .el-table th.is-leaf,
    .el-table td {
        border-bottom: 1px solid rgba(204, 204, 204, 0.5);
    }
}
.group-dialog {
    .el-form-item {
        margin: 0;
    }
    .dialog-footer {
        padding-left: 105px;
    }
}
</style>
<style lang="scss" scoped>
.info-wrap {
    background-color: #fff;
    box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
    position: absolute;
    left: 20px;
    right: 20px;
    bottom: 20px;
    top: 50px;
}
.info-detail {
    display: flex;
    height: 100%;
}
.no-data {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .no-data-content {
        text-align: center;
    }
    .icon {
        font-size: 100px;
    }
    .text {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
    }
    .addHospital {
        color: $a-link;
        cursor: pointer;
    }
}
.hospital-wrap {
    width: 270px;
    box-sizing: border-box;
    overflow: auto;
    border-right: 1px solid #ccc;
    padding: 20px 0;
    .info-search-wrap {
        padding-left: 20px;
        margin-bottom: 16px;
    }
}
.dept-wrap {
    flex: 1;
    overflow: auto;
    padding: 20px;
    .table-wrap {
        .table-none {
            height: 400px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .icon {
                font-size: 100px;
            }
            span {
                line-height: 14px;
            }
        }
    }
}
.title-wrap {
    font-size: 0;
    padding-bottom: 20px;
    height: 16px;
    line-height: 16px;
    .icon-tongyongbiaotiicon {
        color: $color-primary;
        font-size: 16px;
        vertical-align: middle;
    }
    .title-text {
        font-size: 14px;
        color: #333333;
        margin-left: 10px;
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
    }
}
.select-form {
    margin-bottom: 20px;
}
.select-btn-wrap {
    display: inline-block;
    font-size: 0;
}
.option-item {
    display: inline-block;
    font-size: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    .label {
        padding-right: 10px;
        font-size: 14px;
        color: #666;
        display: inline-block;
        text-align: right;
        width: 56px;
    }
}
.link-btn {
    color: $a-link;
    cursor: pointer;
    font-size: 12px;
    display: inline-block;
    height: 14px;
    line-height: 14px;
    border-right: 1px solid $a-link;
    margin-right: 6px;
    padding-right: 6px;
    &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0;
    }
    &.disable-btn {
        color: $disable-link;
        cursor: not-allowed;
    }
}
.hospital-item {
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #333;
    cursor: pointer;
    overflow: hidden;
    &:hover {
        background-color: $hover;
    }
    &.choosed-item {
        color: $color-primary;
        position: relative;
        &:before {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 2px;
            background-color: $color-primary;
            content: "";
        }
    }
}
.hospital-load-text {
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #333;
    text-align: center;
}
</style>
<script>
import { mapGetters } from 'vuex'
import shortcuts from '@/utils/pickerOptions'
import { dateToString } from '@/utils/tools'
export default {
    name: 'hospitalList',
    data () {
        return {
            breadList: [{ label: '医院管理' }, { label: '科室列表' }],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            selectForm: {
                name: '',
                createTime: [],
                startTime: '',
                endTime: '',
                standard: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            },
            hospitalPage: {
                current: 1,
                total: 1,
                pageSize: 15
            },
            searchName: '',
            hospitalList: [],
            deptList: [],
            loading: true,
            allLoading: true,
            choosedHospital: 0,
            standardList: [],
            typeList: [],
            expands: [],
            hospitalLoading: false
        }
    },
    computed: {
        ...mapGetters([
            'dictionary',
            'userInfo'
        ]),
        hospitalNoMore () {
            return Math.ceil(this.hospitalPage.total / this.hospitalPage.pageSize) < this.hospitalPage.current
        },
        hospitalDisabled () {
            return this.hospitalLoading || this.hospitalNoMore
        }
    },
    methods: {
        goHospital () {
            this.$router.push('/hospital/hospitalList/add')
        },
        getRowKeys (row) {
            return row.groupId
        },
        chooseHospital (item, index) {
            this.choosedHospital = index
            this.page.current = 1
            this.selectForm.name = ''
            this.selectForm.createTime = []
            this.selectForm.startTime = ''
            this.selectForm.endTime = ''
            this.selectForm.standard = ''
            this.getData()
        },
        editDetail (type, item) {
            if (item && item.isStandard) {
                return
            }
            if (type === 'edit') {
                this.$router.push({
                    name: 'deptDetail',
                    params: {
                        hospitalId: this.hospitalList[this.choosedHospital].hospitalId,
                        deptId: item.groupId
                    }
                })
            } else if (type === 'add') {
                this.$router.push({
                    name: 'deptDetail',
                    params: {
                        hospitalId: this.hospitalList[this.choosedHospital].hospitalId,
                        deptId: 'add'
                    }
                })
            }
        },
        handleStandardChange (value) {

        },
        handleDateChange (value) {
            if (value) {
                this.selectForm.startTime = value[0] + ' 00:00:00'
                this.selectForm.endTime = value[1] + ' 23:59:59'
            } else {
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
            }
        },
        searchHospital (type) {
            if (type === 'search') {
                this.page.current = 1
                this.getData()
            } else if (type === 'reset') {
                this.page.current = 1
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
                this.selectForm.createTime = []
                this.selectForm.name = ''
                this.selectForm.standard = ''
                this.getData()
            }
        },
        pageChange (value) {
            this.page.current = value
            this.getData()
        },
        async getHospitalData (type) {
            // this.allLoading = true
            // const { results } = await this.$services.hospital.getAllHospitalList({})
            // this.hospitalList = results
            // this.allLoading = false
            // if (this.hospitalList.length > 0) {
            //     this.getData()
            // } else {
            //     this.loading = false
            // }
            if (type === 'search') {
                this.hospitalPage.current = 1
                this.page.current = 1
                this.choosedHospital = 0
                this.page.current = 1
                this.selectForm.name = ''
                this.selectForm.createTime = []
                this.selectForm.startTime = ''
                this.selectForm.endTime = ''
                this.selectForm.standard = ''
            }
            if (Math.ceil(this.hospitalPage.total / this.hospitalPage.pageSize) < this.hospitalPage.current) {
                return
            }
            if (this.hospitalPage.current === 1) {
                this.allLoading = true
            } else {
                this.hospitalLoading = true
            }
            const param = {
                current: this.hospitalPage.current,
                size: this.hospitalPage.pageSize,
                createTimeStart: '',
                createTimeEnd: '',
                hospitalLevelCode: '',
                hospitalAttributeCode: '',
                searchName: this.searchName,
                provinceCode: '',
                cityCode: '',
                districtCode: ''
            }
            const { results, total } = await this.$services.hospital.getHospitalList(param)
            if (this.hospitalPage.current === 1) {
                this.hospitalList = results
                this.hospitalPage.total = total
                this.allLoading = false
                if (this.hospitalList.length > 0) {
                    this.getData()
                } else {
                    this.loading = false
                }
            } else {
                this.hospitalLoading = false
                this.hospitalList = results ? this.hospitalList.concat(results) : this.hospitalList
            }
            this.hospitalPage.current++
        },
        async getData () {
            this.expands = []
            this.loading = true
            const param = {
                current: this.page.current,
                size: this.page.pageSize,
                createTimeStart: this.selectForm.startTime,
                createTimeEnd: this.selectForm.endTime,
                departmentName: this.selectForm.name,
                isStandard: this.selectForm.standard === 'all' ? '' : this.selectForm.standard,
                hospitalId: this.hospitalList[this.choosedHospital].hospitalId
            }
            const { results, total } = await this.$services.hospital.getDeptList(param)
            this.deptList = results
            this.deptList.forEach((item, index) => {
                item.index = index + 1
                if (this.selectForm.name && item.groupName.indexOf(this.selectForm.name) === -1) {
                    this.expands.push(item.groupId)
                }
            })
            this.page.total = total
            this.loading = false
        }
    },
    filters: {
        getDate (value) {
            if (value) {
                const date = new Date(value)
                return dateToString(date, 'yyyy-MM-dd hh:mm')
            } else {
                return value
            }
        }
    },
    created () {
        this.standardList = this.dictionary.STANDARD_DEPT
        this.typeList = this.dictionary.KSDJ
        this.getHospitalData()
    }
}
</script>
